var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ask-modal-white',{attrs:{"whiteButtonText":"Отменить","yellowButtonText":"Изменить","question":"Изменения будут внесены в ваши персональные данные"},on:{"white_button":_vm.cancel,"yellow_button":_vm.accept}})}
var staticRenderFns = []

export { render, staticRenderFns }